import gettext from '@sdk/lang/gettext';

import { MessageMeta } from '@web/conversations/types/Message';

export const getCreationMetaMessage = (message: MessageMeta) => {
  if (message.author.isMe) {
    return gettext('You have started this conversation');
  }

  return gettext('%(name)s has started this conversation', {
    name: message.author.fullname,
  });
};

export const getRenamingMetaMessage = (message: MessageMeta) => {
  const { author } = message;

  if (!message.name) {
    return author.isMe
      ? gettext('You removed the name of this conversation')
      : gettext('%(userName)s removed the name of this conversation', {
          userName: author.fullname,
        });
  }

  if (author.isMe) {
    return gettext('You have renamed this conversation to "%(name)s"', {
      name: message.name,
    });
  }

  return gettext('%(userName)s has renamed this conversation to "%(messageName)s"', {
    userName: author.fullname,
    messageName: message.name,
  });
};
